import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getSingleJob } from "./GetSingleJobApi";


const initialState = {
    singleJob: {},
    isLoading: false,
    isError: false,
    error: "",
};

export const fetchSingleJob = createAsyncThunk('getSingleJob/singlejob', async(id) =>{
    const Jobs = await getSingleJob(id);
    return Jobs;
})
    
const singleJobSlice = createSlice({
    name: "fetchSingleJob",
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(fetchSingleJob.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(fetchSingleJob.fulfilled, (state, action) => {
                state.isError = false;
                state.isLoading = false;
                state.singleJob = action.payload;
            })
            .addCase(fetchSingleJob.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.error = action.error?.message;
                state.singleJob = {};
            })
        }
})


export default singleJobSlice.reducer;